import React from "react"
import ReactDOM from "react-dom"
import ValueCardsContainer from "./value-cards-container-component.jsx"
import "./_value-card.scss"

export default class ValueCardsContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ValueCardsContainer {...self.modelJson} />, self.elem)
  }
}
